import React from 'react'
import CompensationPlanNav from '../components/CompensationPlanNav'

const CompensationPlanLayout = ({ children, ...props }) => {
  return (
    <React.Fragment>
      <CompensationPlanNav></CompensationPlanNav>
      {children}
    </React.Fragment>
  )
}

export default CompensationPlanLayout
